import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ProgramType } from '../../../models/program-type.model';
import { EventTypeService } from '../../services/event-type.service';
import { PartnerWorkshopApi } from '../../services/partner-workshop.service';
import { PartnerUploadHistoryComponent } from '../partner-upload-history/partner-upload-history.component';
import { EventType } from '../../../models/event-type.model';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-partner-workshop-access',
  templateUrl: './partner-workshop-access.component.html',
  styleUrls: ['./partner-workshop-access.component.scss'],
  standalone: true,
  imports: [PartnerUploadHistoryComponent, CommonSharedModule]
})
export class PartnerWorkshopAccessComponent implements OnInit {
  programTypeList!: ProgramType[];
  partnerEventDropdownList!: EventType[];
  partnerWorkshopForm!: FormGroup;
  programForm!: FormGroup;
  isDropdownDisabled = true;
  programTypeSelected!: ProgramType;
  loading = true;

  @ViewChild('uploadHistory', { static: false })
  uploadHistory!: PartnerUploadHistoryComponent;
  isHybridWithCustomerList = false;

  constructor(
    private formBuilder: FormBuilder,
    private partnerworkshopservice: PartnerWorkshopApi,
    private eventTypeService: EventTypeService
  ) {}
  ngOnInit(): void {
    this.loading = true;
    this.onFromGroup();
    this.programTypeDropdown();
  }

  onFromGroup(): void {
    this.programForm = this.formBuilder.group({
      programType: ['']
    });
    this.partnerWorkshopForm = this.formBuilder.group({
      partnerWorkshopType: ['']
    });
  }

  programTypeDropdown(): void {
    this.partnerworkshopservice
      .getProgramTypeDropDown()
      .subscribe(programtypes => {
        this.loading = false;
        this.programTypeList = programtypes;
      });
  }

  workshopTypeDropdown(): void {
    this.eventTypeService
      .getEventTypes(this.programTypeSelected.programTypeId)
      .subscribe(eventtypes => {
        this.partnerEventDropdownList = eventtypes;
        this.loading = false;
      });
  }

  onProgramTypeSelect(): void {
    this.isDropdownDisabled = !this.programForm.controls['programType'].value;
    this.programTypeSelected = this.programForm.controls['programType'].value;
    this.workshopTypeDropdown();
  }

  onWorkshopTypeSelect(): void {
    this.uploadHistory.loadWorkshopUploadHistory(
      this.partnerWorkshopForm.controls['partnerWorkshopType'].value.eventTypeId
    );
    this.uploadHistory.isHybridWithCustomerList =
      this.partnerWorkshopForm.controls[
        'partnerWorkshopType'
      ].value.isHybridWithCustomerList;
    this.isHybridWithCustomerList =
      this.partnerWorkshopForm.controls[
        'partnerWorkshopType'
      ].value.isHybridWithCustomerList;
  }
}
